import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" Edit ");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Cancel");

import { ref } from "vue";
import { useIsMobile } from "@/utils/reactive";
import { LoaderState as LoaderStateEnum } from "@/types/generic";
import GroupEdition from "@/components/groups/GroupEdition.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    group: null,
    label: {
      default: "Edit"
    },
    title: {
      default: "Edit group"
    }
  },
  emits: ["edited", "open", "closed"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var isMobile = useIsMobile();
    var LoaderState = LoaderStateEnum;
    var show = ref(false);
    var edition = ref(null);

    var edited = function edited(group, model) {
      emit("edited", group, model);
      show.value = false;
    };

    return function (_ctx, _cache) {
      var _edition$value, _edition$value2;

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_modal = _resolveComponent("n-modal");

      return _openBlock(), _createElementBlock(_Fragment, null, [_renderSlot(_ctx.$slots, "action", {
        trigger: function trigger() {
          return show.value = true;
        },
        label: __props.label
      }, function () {
        return [_createVNode(_component_n_button, {
          type: "info",
          onClick: _cache[0] || (_cache[0] = function ($event) {
            return show.value = true;
          })
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(__props.label), 1)];
          }),
          _: 1
        })];
      }), _createVNode(_component_n_modal, {
        show: show.value,
        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
          return show.value = $event;
        }),
        "auto-focus": !_unref(isMobile),
        "mask-closable": ((_edition$value = edition.value) === null || _edition$value === void 0 ? void 0 : _edition$value.loader) !== _unref(LoaderState).Loading,
        "close-on-esc": ((_edition$value2 = edition.value) === null || _edition$value2 === void 0 ? void 0 : _edition$value2.loader) !== _unref(LoaderState).Loading,
        title: __props.title,
        preset: "card",
        onAfterEnter: _cache[4] || (_cache[4] = function ($event) {
          return emit('open');
        }),
        onAfterLeave: _cache[5] || (_cache[5] = function ($event) {
          return emit('closed');
        })
      }, {
        footer: _withCtx(function () {
          var _edition$value3, _edition$value5;

          return [_createVNode(_component_n_button, {
            type: "primary",
            loading: ((_edition$value3 = edition.value) === null || _edition$value3 === void 0 ? void 0 : _edition$value3.loader) === _unref(LoaderState).Loading,
            onClick: _cache[1] || (_cache[1] = function ($event) {
              var _edition$value4;

              return (_edition$value4 = edition.value) === null || _edition$value4 === void 0 ? void 0 : _edition$value4.edit();
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_n_button, {
            class: "ms-2",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return show.value = false;
            }),
            disabled: ((_edition$value5 = edition.value) === null || _edition$value5 === void 0 ? void 0 : _edition$value5.loader) === _unref(LoaderState).Loading
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }, 8, ["disabled"])];
        }),
        default: _withCtx(function () {
          return [_createVNode(GroupEdition, {
            ref_key: "edition",
            ref: edition,
            group: __props.group,
            onEdited: edited
          }, {
            action: _withCtx(function () {
              return [_hoisted_1];
            }),
            _: 1
          }, 8, ["group"])];
        }),
        _: 1
      }, 8, ["show", "auto-focus", "mask-closable", "close-on-esc", "title"])], 64);
    };
  }
});